<template>
<div class="chapter">
<div class="inner_page">
<h2 class="bmtitle">FOREWORD</h2>
<p class="noindent">I first met Elizabeth Harris at a PANDAS conference in Atlanta. She was desperate for answers—like many parents of children with pediatric acute-onset neuropsychiatric disorders associated with streptococcus (PANDAS) are. After a long discussion about her son’s case, I agreed to evaluate and treat “Cody.”</p>
<p class="indent">Cody is fortunate to have a mother who trusted her instinct and would not accept what was happening to her beautiful son. She fought for—and found—answers.</p>
<p class="indent">I can happily say through treatment and support, Cody is now grown, free of PANDAS, and leading a very productive life.</p>
<p class="indent">This is not the case for every child with PANDAS.</p>
<p class="indent"><b>One in every 200 children in the United States will develop symptoms of PANDAS.</b> The typical age of onset ranges from four to thirteen; however, at my clinic, I have treated children even younger than four. In the case of the younger patients, they often have a history of hospitalization, including severe infections.</p>
<p class="indent">Many of my patients have either autism or genetic disorders. As a result, pediatricians and parents focus on the primary diagnosis, and the PANDAS remains undiagnosed for far too long while the child and their family suffer in silence.</p>
<p class="indent">Thankfully, PANDAS is becoming more recognizable. We diagnose it based on a combination of clinical history, clinical findings, and extensive laboratory testing, including genetic testing.</p>
<p class="indent">Many changes arise overnight, frequently following an illness, infection, or a medical procedure. Other changes in a child’s behavior may develop gradually and may not be noticed at first by the parent or caregiver.</p>
<p class="indent">These signs include:</p>
<ul class="bullet">
<li>a sudden change in personality,</li>
<li>becoming overly sensitive,</li>
<li>acting up and acting out,</li>
<li>withdrawing from peers,</li>
<li>having trouble with schoolwork,</li>
<li>regression of skills such as handwriting,</li>
<li>psychiatric symptoms such as obsessive-compulsive disorder and tic disorders,</li>
<li>eating disorders, and many more.</li>
</ul>
<p class="indent">Not all children with PANDAS develop the same symptoms, however. As a result, many children are misdiagnosed with having psychiatric disorders. However, many of the psychiatric symptoms are a result of a malfunction in the fever response to infections resulting in neuropsychiatric symptoms.</p>
<p class="indent">Some of the children who exhibit these symptoms and come to see me do not, in fact, have PANDAS.</p>
<p class="indent">After extensive testing, once we have confirmed that a child <i>does</i> have PANDAS, we aim to identify the root problem, and then move forward, aiming to do all we can to help the child, and by extension, the family.</p>
<p class="indent">Early evaluation and treatment are crucial for recovery, as in a team approach. If both parents, the primary care physician, as well at the school team can be on board with treating a child, we tend to have greater success.</p>
<p class="indent">I commend Elizabeth for her courage and strength, and I pray that this book will offer insight to help save many children from a life of suffering.</p>
<p class="right"><b>Rosario R. Trifiletti, MD PhD</b></p>
<p class="right">Child Neurologist</p>
<p class="right">The PANDAS/PANS Institute</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?5ef5e91a